import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthTokenStore } from './auth-token.store';

/**
 * True only for the API itself or paths below it. A bare prefix check would also match
 * `https://api.example.com.evil.net/...`. API_URL may be absolute or relative (`/ev-api` in the lan build).
 */
function isApiUrl(url: string): boolean {
  let base = environment.API_URL;
  while (base.endsWith('/')) base = base.slice(0, -1);
  return url === base || url.startsWith(base + '/') || url.startsWith(base + '?');
}

/** Attaches a Bearer token to every request destined for the backend API. */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenStore = inject(AuthTokenStore);
  const token = tokenStore.get();

  if (!token || !isApiUrl(req.url)) {
    return next(req);
  }

  const authReq = req.clone({
    setHeaders: { Authorization: `Bearer ${token}` }
  });

  return next(authReq);
};
